import { createApiHook, useApi } from "../utils/apiUtils";

const useUpdateAnswerOption = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateAnswerOption = async (id, payload) => {
    startLoading();
    const response = await apiPatch(`/answer_options/${id}`, "Error al actualizar la opción de respuesta", { answer_option: payload });
    setResponse(response);

    if (response?.error) {
      const err = new Error(response.error.message || "No se pudo actualizar la opción de respuesta");
      err.backend = response.error;
      throw err;
    }
    return response;
  };

  return { updateAnswerOption, data, loading, error };
};

export default useUpdateAnswerOption;
